<div [formGroup]="formGroup" class="datepicker-div">
	<div>
		<input id="{{id}}" [nbDatepicker]="datepicker" [formControlName]="controlName"
			   [attr.formcontrolname]="controlName" [placeholder]="'common.date-picker.pick-date' | translate" nbInput
			   fullWidth
			   readonly (keydown)="keyPressed($event)">
		<nb-datepicker #datepicker (dateChange)="triggerOnDateChangeInDefault($event)"></nb-datepicker>
		<div class="clear-selection" (click)="triggerOnDateChangeInDefault(null)">
			<nb-icon icon="close-circle"></nb-icon>
			<label>{{'common.date-picker.clear-selection' | translate}}</label>
		</div>
	</div>
</div>
